import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconContact = ({ id, color, width = 49, style, ...restProps }: IProps) => {
  const viewBoxWidth = 49;
  const viewBoxHeight = 34;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        fillRule="evenodd"
        d="M43.534 30.826L28.961 19.32a1.645 1.645 0 0 1-.494-.643l-2.314 1.562c-.29.197-.63.295-.968.295a1.73 1.73 0 0 1-.97-.295l-2.287-1.545a1.7 1.7 0 0 1-.576.778l-15.2 11.353h37.382zm2.221-2.453V7.007l-14.588 9.849 14.588 11.517zm-42.51.422l15.972-11.93L3.245 6.083v22.712zM4.81 3.175l20.374 13.753L45.318 3.337a.972.972 0 0 0-.536-.163H4.81zM44.781 34H4.219C1.892 34 0 32.149 0 29.874V4.126C0 1.851 1.892 0 4.218 0h40.564C47.108 0 49 1.851 49 4.126v25.748C49 32.149 47.108 34 44.782 34z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconContact;
